import { render } from "./PdpRpaSkuStockStatus.vue?vue&type=template&id=3634a2a2"
import script from "./PdpRpaSkuStockStatus.vue?vue&type=script&lang=js"
export * from "./PdpRpaSkuStockStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__